import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, Dialog, TextField } from "@mui/material";
import { useState } from "react";

import { useAppDispatch, useAppSelector } from "../../app/hooks";
import logoImg from "../../assets/imgs/garage/cargo.png";
import { GarageActions } from "../../constants/enum/garage";
import {
  isEthereumAddress,
  isStartWith0x,
  shortAddress,
} from "../../utils/utils";

import useStyles from "./GarageTransferStyles";

import { toast } from "react-toastify";
import { dispatchTxAction } from "../../helper/dispatchTxAction";
import useWallet from "../../hook/useWallet";
import { getGarageListAction } from "../../reducers/game.slice";
import { bulkTransferInventoryItems } from "../../reducers/profile.slice";
import { CarInventoryType } from "../../types/CarInventoryType";

interface GarageTransferPopupProps {
  openModal: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  setActionType: (actionType: GarageActions | "") => void;
  targetItem: CarInventoryType | null;
}

const GarageTransferPopup: React.FC<GarageTransferPopupProps> = ({
  openModal,
  setOpenModal,
  setActionType,
  targetItem,
}) => {
  const { classes } = useStyles();
  const [label, setLabel] = useState("Input player name");
  const [playerName, setPlayerName] = useState("");

  const { profileNames } = useAppSelector((state) => state.profile);
  const dispatch = useAppDispatch();
  const { account } = useWallet();
  const { myProfile } = useAppSelector((state) => state.profile);

  const handleClose = () => {
    setOpenModal(false);
    setActionType("");
  };

  const handleOnChangeName = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    const playerName = e.target.value;
    setPlayerName(playerName);

    if (isStartWith0x(playerName)) {
      if (isEthereumAddress(playerName)) {
        const profile = profileNames.find(
          (profileName, index) => profileName.address === playerName
        );

        if (profile) {
          setLabel(profile.name || "");
        } else {
          setLabel("No profile exist.");
        }
      } else {
        setLabel("Invalid address.");
      }
    } else {
      const profile = profileNames.find(
        (profileName, index) => profileName.name === playerName
      );

      if (profile) {
        setLabel(shortAddress(profile.address || ""));
      } else {
        setLabel("");
      }
    }
  };

  const handleTransferItem = () => {
    const profile = profileNames.find(
      (profileName, index) =>
        profileName.name === playerName || profileName.address === playerName
    );

    if (profile && profile.address && targetItem) {
      if (!isStartWith0x(playerName)) {
        dispatchTxAction(
          dispatch,
          bulkTransferInventoryItems({
            account,
            itemIds: [targetItem.id],
            to: profile.address,
          }),
          () => {
            setOpenModal(false);
            toast.success("Successfully transferred a car.");
            if (myProfile.city === undefined) return;
            dispatch(getGarageListAction({ account }));
          }
        );
      }
    }
  };

  return (
    <Dialog open={openModal} onClose={handleClose} className={classes.body}>
      <Box className={classes.modalContent}>
        <Box className={classes.closeIconBody}>
          <Button onClick={handleClose}>
            <CloseIcon htmlColor="gray" />
          </Button>
        </Box>

        <Box className={classes.contentBody}>
          <Box component={"img"} src={logoImg} className={classes.logoImg} />
          <Box className={classes.titleText}>Transfer car</Box>
          <Box>
            {targetItem?.carType.carName} - {targetItem?.car.damagePercent}%
            damage
          </Box>
          <Box
            component={"img"}
            src={`/assets/imgs/cars/${targetItem?.carType.image}.png`}
            className={classes.carImg}
          />
          <Box>
            <TextField
              placeholder="Input player name"
              variant="standard"
              className={classes.inputBox}
              InputProps={{
                disableUnderline: true, // Disable the underline
              }}
              value={playerName}
              onChange={handleOnChangeName}
              autoComplete="off"
              sx={{
                input: {
                  "&::placeholder": {
                    opacity: 1,
                  },
                },
              }}
            />
          </Box>
          <label>{label}</label>
          <Box className={classes.buttonGroup}>
            <Button variant="contained" onClick={handleTransferItem}>
              Confirm
            </Button>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};

export default GarageTransferPopup;
